
import React, { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

const HealthWellnessPage = lazy(() => import("@/pages/calculators/HealthWellnessPage"));
const BMICalculatorPage = lazy(() => import("@/pages/calculators/health/BMICalculatorPage"));
const CaloriesCalculatorPage = lazy(() => import("@/pages/calculators/health/CaloriesCalculatorPage"));
const MacroCalculatorPage = lazy(() => import("@/pages/calculators/health/MacroCalculatorPage"));
const DueDateCalculatorPage = lazy(() => import("@/pages/calculators/health/DueDateCalculatorPage"));
const ProteinCalculatorPage = lazy(() => import("@/pages/calculators/health/ProteinCalculatorPage"));
const TDEECalculatorPage = lazy(() => import("@/pages/calculators/health/TDEECalculatorPage"));
const OvulationCalculatorPage = lazy(() => import("@/pages/calculators/health/OvulationCalculatorPage"));
const ConceptionCalculatorPage = lazy(() => import("@/pages/calculators/health/ConceptionCalculatorPage"));
const PregnancyCalculatorPage = lazy(() => import("@/pages/calculators/health/PregnancyCalculatorPage"));
const BodyfatCalculatorPage = lazy(() => import("@/pages/calculators/health/BodyfatCalculatorPage"));
const IdealWeightCalculatorPage = lazy(() => import("@/pages/calculators/health/IdealWeightCalculatorPage"));
const BMRCalculatorPage = lazy(() => import("@/pages/calculators/health/BMRCalculatorPage"));
const SleepCalculatorPage = lazy(() => import("@/pages/calculators/health/SleepCalculatorPage"));
const WaterIntakeCalculatorPage = lazy(() => import("@/pages/calculators/health/WaterIntakeCalculatorPage"));

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="flex items-center justify-center min-h-[50vh]"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" /></div>}>
    {children}
  </Suspense>
);

const HealthRoutes = [
  <Route path="/calculators/health-wellness" element={<Lazy><HealthWellnessPage /></Lazy>} key="health-wellness" />,
  <Route path="/calculators/health-wellness/bmi" element={<Lazy><BMICalculatorPage /></Lazy>} key="bmi" />,
  <Route path="/calculators/health-wellness/calories" element={<Lazy><CaloriesCalculatorPage /></Lazy>} key="calories" />,
  <Route path="/calculators/health-wellness/macro" element={<Lazy><MacroCalculatorPage /></Lazy>} key="macro" />,
  <Route path="/calculators/health-wellness/due-date" element={<Lazy><DueDateCalculatorPage /></Lazy>} key="due-date" />,
  <Route path="/calculators/health-wellness/protein" element={<Lazy><ProteinCalculatorPage /></Lazy>} key="protein" />,
  <Route path="/calculators/health-wellness/tdee" element={<Lazy><TDEECalculatorPage /></Lazy>} key="tdee" />,
  <Route path="/calculators/health-wellness/ovulation" element={<Lazy><OvulationCalculatorPage /></Lazy>} key="ovulation" />,
  <Route path="/calculators/health-wellness/conception" element={<Lazy><ConceptionCalculatorPage /></Lazy>} key="conception" />,
  <Route path="/calculators/health-wellness/pregnancy" element={<Lazy><PregnancyCalculatorPage /></Lazy>} key="pregnancy" />,
  <Route path="/calculators/health-wellness/bodyfat" element={<Lazy><BodyfatCalculatorPage /></Lazy>} key="bodyfat" />,
  <Route path="/calculators/health-wellness/ideal-weight" element={<Lazy><IdealWeightCalculatorPage /></Lazy>} key="ideal-weight" />,
  <Route path="/calculators/health-wellness/bmr" element={<Lazy><BMRCalculatorPage /></Lazy>} key="bmr" />,
  <Route path="/calculators/health-wellness/sleep" element={<Lazy><SleepCalculatorPage /></Lazy>} key="sleep" />,
  <Route path="/calculators/health-wellness/water-intake" element={<Lazy><WaterIntakeCalculatorPage /></Lazy>} key="water-intake" />,
];

export default HealthRoutes;
